import React from 'react';
import imageConfig from '../data/images.json';

interface ImageEntry {
  width: number;
  height: number;
  widths: number[];
}

const config = imageConfig as { outputDir: string; formats: string[]; images: Record<string, ImageEntry> };

// Muss zu variantName() in scripts/optimize-images.js passen
const variantUrl = (src: string, width: number, format: string) => {
  const file = src.substring(src.lastIndexOf('/') + 1);
  return `${config.outputDir}/${file.substring(0, file.lastIndexOf('.'))}-${width}.${format}`;
};

export const getImageEntry = (src: string): ImageEntry | undefined => config.images[src];

interface PictureProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet' | 'width' | 'height'> {
  src: string;
  alt: string;
  // Tatsächliche Darstellungsbreite, damit der Browser die passende Variante lädt
  sizes: string;
  // Für das wichtigste Bild über dem Falz (LCP): sofort und mit hoher Priorität laden
  priority?: boolean;
}

// <picture> mit AVIF/WebP-Varianten aus scripts/optimize-images.js; das Original bleibt Fallback
const Picture: React.FC<PictureProps> = ({ src, alt, sizes, priority = false, loading, decoding, ...imgProps }) => {
  const entry = config.images[src];

  const img = (
    <img
      src={src}
      alt={alt}
      width={entry?.width}
      height={entry?.height}
      loading={priority ? 'eager' : loading ?? 'lazy'}
      decoding={decoding ?? (priority ? 'auto' : 'async')}
      {...(priority ? { fetchpriority: 'high' } : {})}
      {...imgProps}
    />
  );

  if (!entry) return img;

  return (
    <picture className="contents">
      {config.formats.map((format) => (
        <source
          key={format}
          type={`image/${format}`}
          sizes={sizes}
          srcSet={entry.widths.map((width) => `${variantUrl(src, width, format)} ${width}w`).join(', ')}
        />
      ))}
      {img}
    </picture>
  );
};

export default Picture;
